import { createAsyncThunk } from '@reduxjs/toolkit';
import { Offer, ReportsApi } from 'api/ReportsApi';

export const createGetOffersThunk = (api: ReportsApi) =>
  createAsyncThunk<Offer[], string>('reports/getOffers', async (applicationId, thunkApi) => {
    try {
      return await api.getOffers(applicationId);
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  });
